import { useState, useEffect } from 'react';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const _cache = {};

export function useAnnexe(pays = 'FR') {
  const [annexe, setAnnexe] = useState(_cache[pays] || null);
  const [loading, setLoading] = useState(!_cache[pays]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (_cache[pays]) {
      setAnnexe(_cache[pays]);
      setLoading(false);
      return;
    }
    setLoading(true);
    fetch(`${API_BASE}/annexe/${pays}`)
      .then(r => {
        if (!r.ok) throw new Error(`Annexe '${pays}' non trouvée`);
        return r.json();
      })
      .then(data => {
        _cache[pays] = data;
        setAnnexe(data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, [pays]);

  return { annexe, loading, error };
}
